import { FORM_RESPONSE } from '../actionTypes'

const init = { data: [], current: null, loading: false, error: null }

export default function formResponsesReducer(state = init, action) {
  switch (action.type) {
    case FORM_RESPONSE.LIST_REQUEST:
      return { ...state, loading: true, error: null }
    case FORM_RESPONSE.LIST_SUCCESS:
      return { ...state, loading: false, data: action.data, error: null }
    case FORM_RESPONSE.LIST_FAILURE:
      return { ...state, loading: false, error: action.error }
    case FORM_RESPONSE.GET_ONE_REQUEST:
      return { ...state, loading: true, error: null }
    case FORM_RESPONSE.GET_ONE_SUCCESS:
      return { ...state, loading: false, current: action.data, error: null }
    case FORM_RESPONSE.GET_ONE_FAILURE:
      return { ...state, loading: false, error: action.error }
    case FORM_RESPONSE.CREATE_REQUEST:
    case FORM_RESPONSE.UPDATE_REQUEST:
      return { ...state, loading: true, error: null }
    case FORM_RESPONSE.CREATE_SUCCESS:
      return { ...state, loading: false, data: [action.data, ...state.data], error: null }
    case FORM_RESPONSE.UPDATE_SUCCESS:
      return { ...state, loading: false, data: state.data.map((d) => (String(d.id) === String(action.data?.id) || String(d.uuid) === String(action.data?.uuid) ? action.data : d)), error: null }
    case FORM_RESPONSE.CREATE_FAILURE:
    case FORM_RESPONSE.UPDATE_FAILURE:
      return { ...state, loading: false, error: action.error }
    case FORM_RESPONSE.DELETE_REQUEST:
      return { ...state, loading: true, error: null }
    case FORM_RESPONSE.DELETE_SUCCESS: {
      const deletedId = String(action.id)
      return {
        ...state,
        loading: false,
        data: state.data.filter((d) => {
          const did = d.id ?? d.uuid ?? d.submissionId ?? d.submission_id
          return String(did) !== deletedId
        }),
        error: null
      }
    }
    case FORM_RESPONSE.DELETE_FAILURE:
      return { ...state, loading: false, error: action.error }
    case FORM_RESPONSE.CLEAR:
      return init
    default:
      return state
  }
}
